import request from '@/utils/request';

export interface CartItem {
    id: number;
    sku_id: number;
    product_id: number;
    title: string;
    image: string;
    specs: string[];
    price: number;
    original_price?: number;
    quantity: number;
    stock: number;
    selected: boolean;
    services: string[];
    rebate_amount: number;
    product_type?: string;
    merchant_id?: number;
    rebate_rate?: number;
    consumer_rebate_rate?: number;
}

export interface CartShop {
    id: number;
    shop_id?: number;
    name: string;
    selected: boolean;
    items: CartItem[];
}

export interface CartListResponse {
    total_count: number;
    total_price: number;
    list: CartShop[];
}

export function getCartList() {
    return request({
        url: '/cart/list',
        method: 'GET'
    }) as Promise<CartListResponse>;
}

export function addCartItem(data: { sku_id: number; quantity: number; merchant_id: number }) {
    return request({
        url: '/cart/item',
        method: 'POST',
        data
    });
}

export function updateCartItem(id: number, quantity: number) {
    return request({
        url: `/cart/item/${id}`,
        method: 'PUT',
        data: { quantity }
    });
}

export function deleteCartItem(id: number) {
    return request({
        url: `/cart/item/${id}`,
        method: 'DELETE'
    });
}

export function checkCartItems(data: { sku_ids: number[]; selected: boolean; clear_others?: boolean }) {
    return request({
        url: '/cart/check',
        method: 'POST',
        data
    });
}

export function getCartCount() {
    return request({
        url: '/cart/count',
        method: 'GET'
    });
}
